export const normalizeDrawingTypes = (raw) => {
  const list = Array.isArray(raw)
    ? raw
    : Array.isArray(raw?.drawing_types)
      ? raw.drawing_types
      : Array.isArray(raw?.types)
        ? raw.types
        : [];

  return list
    .map((item) => {
      if (typeof item === 'string') {
        return { value: item, label: item };
      }
      const value = item?.value ?? item?.id ?? item?.key ?? item?.drawing_type ?? '';
      const label = item?.label ?? item?.name ?? item?.title ?? value;
      return { value: String(value), label: String(label) };
    })
    .filter((item) => item.value);
};

export const normalizeDrawings = (raw) => {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw.map((item, index) => ({
      id: item?.id ?? item?.drawing_id ?? `drawing-${index}`,
      drawingType: item?.drawing_type ?? item?.drawingType ?? item?.type ?? 'Other',
      name: item?.name ?? item?.display_name ?? item?.file_name ?? item?.fileName ?? 'Drawing',
      url: item?.url ?? item?.file_url ?? item?.fileUrl ?? item?.link ?? '',
      fileKey:
        item?.file_key ??
        item?.s3_key ??
        item?.fileKey ??
        item?.key ??
        item?.storage_key ??
        ''
    }));
  }

  if (typeof raw === 'object') {
    if (Array.isArray(raw.drawings)) {
      return normalizeDrawings(raw.drawings);
    }

    return Object.entries(raw).flatMap(([type, files]) => {
      if (!Array.isArray(files)) return [];
      return files.map((item, index) => ({
        id: item?.id ?? `${type}-${index}`,
        drawingType: item?.drawing_type ?? item?.drawingType ?? type,
        name: item?.name ?? item?.display_name ?? item?.file_name ?? item?.fileName ?? 'Drawing',
        url: item?.url ?? item?.file_url ?? item?.fileUrl ?? item?.link ?? '',
        fileKey:
          item?.file_key ??
          item?.s3_key ??
          item?.fileKey ??
          item?.key ??
          item?.storage_key ??
          ''
      }));
    });
  }

  return [];
};

export const groupDrawingsByType = (drawings) => {
  const groups = new Map();
  drawings.forEach((drawing) => {
    const type = drawing.drawingType || 'Other';
    if (!groups.has(type)) groups.set(type, []);
    groups.get(type).push(drawing);
  });
  return Array.from(groups.entries()).map(([type, items]) => ({ type, items }));
};

export const buildDrawingDeletePayload = (drawing) => {
  const drawing_type = String(drawing?.drawingType ?? drawing?.drawing_type ?? '').trim();
  const file_key = String(drawing?.fileKey ?? drawing?.file_key ?? '').trim();

  if (!drawing_type || !file_key) {
    throw new Error('Drawing is missing drawing type or file key.');
  }

  return { drawing_type, file_key };
};
